export const handleFocus = () => {
    if (document.getElementById("search-results")) {
        document.getElementById("search-results").classList.remove("hide");
    }
}